export default __webpack_public_path__ + "static/eyecatch-d936123775e03560e3fbec2c118854dd.mp4";